import getCredentialImpact from '@/redux/actions/getCredentialImpact.js';
import selectors from '@/redux/selectors/selectors.js';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useCredentialEditWarning = ({ credential, enabled = true }) => {
  const companyId = useSelector(selectors.companyId);
  const userId = useSelector(selectors.userId);
  const [acknowledgedSession, setAcknowledgedSession] = useState(null);
  const credentialId = credential?.credentialId;
  const session = `${companyId}:${credentialId}:${userId}`;
  const required = enabled && credential?.isCompany === true && credential?.companyId !== 'MINDCLOUD' && (!credential?.createdBy || credential.createdBy !== userId);
  const acknowledged = acknowledgedSession === session;
  const impact = useSelector((state) => state.workflow.credentialImpact?.[companyId]?.[credentialId]);

  useEffect(() => {
    setAcknowledgedSession(null);
    if (required) {
      getCredentialImpact({ companyId, credentialId });
    }
  }, [session, required]);

  return {
    required,
    blocked: required && !acknowledged,
    impact,
    acknowledge: () => setAcknowledgedSession(session)
  };
};

export default useCredentialEditWarning;
